import axios from 'axios'
import { API_URL } from '../../config'

export function login(payload) {
  const { username, password } = payload
  return axios({
    method: 'POST',
    url: `${API_URL}/login`,
    data: { username, password },
  }).then((response) => response.data)
}

export function getProfile(token) {
  return axios({
    method: 'GET',
    url: `${API_URL}/profile`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }).then((response) => response.data)
}

export function updateProfile(token, payload, updateUploadProgress) {
  const formData = new FormData()
  for (var key in payload) {
    formData.append(key, payload[key])
  }
  formData.append('_method', 'PUT')
  return axios({
    method: 'POST',
    url: `${API_URL}/profile`,
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `Bearer ${token}`,
    },
    data: formData,
    onUploadProgress: (ev) => {
      const progress = (ev.loaded / ev.total) * 100
      updateUploadProgress(Math.round(progress))
    },
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err.response.data.errors
    })
}

export function getUserPermissions(token) {
  return axios({
    method: 'GET',
    url: `${API_URL}/user-permissions`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }).then((response) => response.data)
}

export function getAllPermissions(token) {
  return axios({
    method: 'GET',
    url: `${API_URL}/permissions`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }).then((response) => response.data)
}

export function forgotPassword(payload) {
  return axios({
    method: 'POST',
    url: `${API_URL}/forgot-password`,
    data: payload,
  }).then((response) => response.data)
}

export function checkTokenForgotPassword(payload) {
  return axios({
    method: 'POST',
    url: `${API_URL}/check-token`,
    data: payload,
  }).then((response) => response.data)
}

export function changeForgotPassword(payload) {
  return axios({
    method: 'POST',
    url: `${API_URL}/reset-password`,
    data: payload,
  }).then((response) => response.data)
}
